import JustValidate from 'just-validate';
import { nameRules, birthdateRulesFormat, emailRulesFormat } from '../../assets/scripts/utils/validationRules';
import Utils from '../../assets/scripts/utils/utils';

class Profile {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-profile]');

		if (!this.container) return;

		this._initHeader();
		this._initAccountData();
		// this._initAddressData();
	}

	_initAccountData() {
		const form = this.container.querySelector('[data-profile-form="account-data"]');

		if (!form) {
			return;
		}

		const submitButton = form.querySelector('button[type="submit"]');
		const inputs = Array.from(form.querySelectorAll('input, textarea, select'));
		const initialValues = new Map(inputs.map((input) => [input.id, input.value]));

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;
		form.inited = true;

		validator
			.addField('#user-name', nameRules, {
				errorsContainer: Utils.getErrorContainer('#user-name'),
			})
			.addField('#user-surname', nameRules, {
				errorsContainer: Utils.getErrorContainer('#user-surname'),
			})
			.addField('#user-birthdate', birthdateRulesFormat, {
				errorsContainer: Utils.getErrorContainer('#user-birthdate'),
			})
			.addField('#user-tel', [{ rule: 'required' }], {
				errorsContainer: Utils.getErrorContainer('#user-tel'),
			})
			.addField('#user-email', emailRulesFormat, {
				errorsContainer: Utils.getErrorContainer('#user-email'),
			})
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});

		// const hasChanges = () => {
		// 	return inputs.some((input) => input.value !== initialValues.get(input.id));
		// };
		// const hasTochedInputsWithErrors = () => {
		// 	return inputs.some((input) => {
		// 		return input.classList.contains('just-validate-error-field');
		// 	});
		// };

		// const toggleButton = () => {
		// 	if (hasChanges() && !hasTochedInputsWithErrors()) {
		// 		submitButton.disabled = false;
		// 	} else {
		// 		submitButton.disabled = true;
		// 	}
		// };

		// inputs.forEach((input) => {
		// 	input.addEventListener('input', toggleButton);
		// 	input.addEventListener('change', toggleButton);
		// });
	}
	/*
	_initAddressData() {
		const form = this.container.querySelector('[data-profile-form="address-data"]');

		if (!form) {
			return;
		}

		const submitButton = form.querySelector('button[type="submit"]');
		const inputs = Array.from(form.querySelectorAll('input, textarea, select'));
		const initialValues = new Map(inputs.map((input) => [input.name, input.value]));
		const countrySelect = form.querySelector('[data-select="address-data-country"]').customSelect;
		const cityInput = this.container.querySelector('#address-data-city');
		const addressInput = this.container.querySelector('#address-data-address');

		countrySelect.select.addEventListener('change', () => {
			cityInput.customInput.setValue('');
			addressInput.customInput.setValue('');
		});
		cityInput.addEventListener('change', () => {
			addressInput.customInput.setValue('');
		});

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;
		form.inited = true;

		const toggleButton = async () => {
			validator.validate();
		};

		inputs.forEach((input) => {
			input.addEventListener('change', toggleButton);
		});

		validator
			.addField(
				'#address-data-city',
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					{
						validator: (value, fields) => {
							const input = fields['#address-data-city']?.elem;
							return input.getAttribute('data-hint-value') === value;
						},
						errorMessage: 'Выберите город из списка',
					},
				],
				{
					errorsContainer: Utils.getErrorContainer('#address-data-city'),
				},
			)
			.addField(
				'#address-data-address',
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					{
						validator: (value, fields) => {
							const input = fields['#address-data-address']?.elem;
							return input.getAttribute('data-hint-value') === value;
						},
						errorMessage: 'Выберите адрес из списка',
					},
				],
				{
					errorsContainer: Utils.getErrorContainer('#address-data-address'),
				},
			)
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});
	}
*/
	_initHeader() {
		const navList = this.container.querySelector('.profile-header__nav');
		const navListWrapper = this.container.querySelector('.profile-header__nav-wrapper');
		const opener = this.container.querySelector('.profile-header__nav-opener');

		window.addEventListener('click', (evt) => {
			if (navListWrapper.contains(evt.target)) {
				return;
			}

			navList.classList.remove('_opened');
		});

		opener.addEventListener('click', () => {
			navList.classList.toggle('_opened');
		});
	}
}

export default new Profile();
